// extracted by mini-css-extract-plugin
export default {"title":"TermsOfUse_title__l90XN","bodyText":"TermsOfUse_bodyText__aBDuV","link":"TermsOfUse_link__k8fBA","boldText":"TermsOfUse_boldText__tX5OB"};